import { PermitSitePhotosTabActionTypes, ADD_SITE_PHOTO, DELETE_SITE_PHOTO } from "./types";
import { RawFile } from "../../models/RawFile";
import { PermitAffectedService } from "../../models/PermitAffectedService";

export function addSitePhoto(
    sitePhotoFileKey: string,
    photoFile: RawFile,
    createdById: string,
    comments: string,
    affectedService?: PermitAffectedService,
    noPhotoReason?: string
): PermitSitePhotosTabActionTypes {
    return {
        type: ADD_SITE_PHOTO,
        sitePhotoFileKey,
        photoFile,
        createdById,
        comments,
        affectedService,
        noPhotoReason,
    };
}

export function deleteSitePhoto(sitePhotoId: string): PermitSitePhotosTabActionTypes {
    return {
        type: DELETE_SITE_PHOTO,
        sitePhotoId,
    };
}
